export const PAPER_DEFAULT_THEME = {
  radius: {
    xs: {
      radius: 8
    },
    s: {
      radius: 12
    },
    m: {
      radius: 20
    }
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtaW5nL2NyZWF0ZVRoZW1lL2NvbXBvbmVudHMvUGFwZXIudGhlbWUudHMiXSwibmFtZXMiOlsiUEFQRVJfREVGQVVMVF9USEVNRSIsInJhZGl1cyIsInhzIiwicyIsIm0iXSwibWFwcGluZ3MiOiJBQUVBLE9BQU8sTUFBTUEsbUJBQStCLEdBQUc7QUFDM0NDLEVBQUFBLE1BQU0sRUFBRTtBQUNKQyxJQUFBQSxFQUFFLEVBQUU7QUFDQUQsTUFBQUEsTUFBTSxFQUFFO0FBRFIsS0FEQTtBQUlKRSxJQUFBQSxDQUFDLEVBQUU7QUFDQ0YsTUFBQUEsTUFBTSxFQUFFO0FBRFQsS0FKQztBQU9KRyxJQUFBQSxDQUFDLEVBQUU7QUFDQ0gsTUFBQUEsTUFBTSxFQUFFO0FBRFQ7QUFQQztBQURtQyxDQUF4QyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFBhcGVyVGhlbWUgfSBmcm9tICcuLi8uLi90eXBlcyc7XG5cbmV4cG9ydCBjb25zdCBQQVBFUl9ERUZBVUxUX1RIRU1FOiBQYXBlclRoZW1lID0ge1xuICAgIHJhZGl1czoge1xuICAgICAgICB4czoge1xuICAgICAgICAgICAgcmFkaXVzOiA4LFxuICAgICAgICB9LFxuICAgICAgICBzOiB7XG4gICAgICAgICAgICByYWRpdXM6IDEyLFxuICAgICAgICB9LFxuICAgICAgICBtOiB7XG4gICAgICAgICAgICByYWRpdXM6IDIwLFxuICAgICAgICB9LFxuICAgIH0sXG59O1xuIl19